import styled from 'styled-components'
import { ifNotProp, ifProp } from 'styled-tools'

export const Container = styled.div<{ hasPrefix: boolean; hasSuffix: boolean }>`
  position: relative;
  width: 100%;
  input {
    padding-left: ${ifProp('hasPrefix', '40px')};
    padding-right: ${ifProp('hasSuffix', '40px')};
  }
`

export const Addon = styled.span<{ before: boolean }>`
  position: absolute;
  height: 100%;
  width: ${ifProp('before', '40px')};
  min-width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: ${ifProp('before', 0)};
  right: ${ifNotProp('before', 0)};
`
